// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    DialogContentText,
    Input,
    ListItemIcon,
    ListItemText, TextField,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {changeWorkQueue} from "../../workQueueSlice";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import {changeWorkSubmitting} from "../../../Work/workSubmittingSlice";
import {addChildContracts, advanceContract, createNewContract, getQueueC} from "../../../Contract/ContractClient";
import {updateExistingExpressions} from "../../../ContractDataPointValue/ContractDataPointValueClient";
import {useEffect} from "react";
import {changeProduct} from "../../../ExternalData/Product/productSlice";


// main function
export default function AddContract({ onMenuClose, rowContractData }) {

    const currentUserId = useSelector((state) => state.userProfileSlc.value.userId);
    const currentUserName = useSelector((state) => state.userProfileSlc.value.userName);
    const currentUserContractType = useSelector((state) => state.userProfileSlc.value.userContractType);



    const selectorContractId = useSelector((state) => state.workQueueSlc.value.mousedContractId);
    const selectorContractName = useSelector((state) => state.workQueueSlc.value.mousedContractName);
    const selectorContractLevel = useSelector((state) => state.workQueueSlc.value.mousedContractContractLevel);
    const selectorContractProduct = useSelector((state) => state.workQueueSlc.value.mousedContractPropertyId);
    const selectorContractGuild = useSelector((state) => state.workQueueSlc.value.mousedContractGuild);
    const [contractCount, setContractCount] = React.useState([1]);




    const [confirmOpen, setConfirmOpen] = React.useState(false);

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleAddClick = () => {
         if(selectorContractLevel === "Property")
        {
        console.log("guildMultiSelectState should open now.")
        dispatchData(changeWorkQueue({
            productGuildDialogueState: true}));
            dispatchData(changeProduct({id: selectorContractProduct, guildMultiSelectState: true}));}
        else
        {setConfirmOpen(true);}
    };


    const handleConfirmClose = () => {
        setConfirmOpen(false);
        onMenuClose();
        dispatchData(changeWorkQueue({actionMenuState: false }));
    };

    // const handleAddGuilds = () => {
    //     console.log("handleAddGuilds triggered.")
    //     console.log("this is supposed to open the guild multi-select dialogue.")
    //     // dispatchData(changeWorkQueue({
    //     //     guildMultiSelectState: true}));
    // }

    const handleConfirmAdd = (rowData) => {
        setConfirmOpen(false);
        onMenuClose();
        console.log("Adding Contract(s) from action menu");
        dispatchData(changeWorkQueue({
            actionMenuAction: "Add",
            actionMenuState: false }));

            console.log("handleConfirmAdd triggered from Add Contract(s) from grid actions");
            console.log("selectorContractId = ", selectorContractId);
            if(selectorContractId > 0) {
// trigger function
                console.log("adding contract(s) from contract grid");
                console.log("adding to this contract via selectorContractId ", selectorContractId);
                console.log("adding this many new contracts ", contractCount)
                dispatchData(changeWorkSubmitting({submitting: true }));
                addChildContracts(selectorContractId, contractCount)
                    .then(()=>dispatchData(changeWorkQueue({workQueueCGridRefresh: true})))
                // }else{createNewDataSet()
                // }else{createNewContract(currentUserId, currentUserName, currentUserContractType)
            }else{createNewContract(currentUserId, currentUserName, currentUserContractType)

                .then(data => {
                    dispatchData(changeWorkQueue({
                        selectedContractId: data, selectedContractStatus: "NEW" , cId: data,
                        selectedContractSectionId: 0,
                        workQueueCSGridRefresh: true,
                        workQueueCDPGridRefresh: true
                    }));
                    dispatchData(changeWorkSubmitting({submitting: false }));
                    console.log('This is my newly generated contract id', data);
                    // console.log(data);
                    advanceContract(data).then(() => {
                        // callback(fetchWorkQueueCDP);
                        // dispatchData(changeWorkQueue({workQueueAdvanceState: true}));
                        console.log("Advance Contract: ",data );
                        // console.log(selectorContractId);
                    })
                        .then(() => {
                            updateExistingExpressions(data);
                        })
                        .then(() => {
                            getQueueC()

                                .then(data => {
                                    console.log("get Queue C: ",data );
                                    dispatchData(changeWorkSubmitting({submitting: false }));

                                })
                            // dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
                            // dispatchData(changeWorkQueue({workQueueCDPGridRefresh: true}));
                        })            .finally(()=>{
                        dispatchData(changeWorkSubmitting({submitting: false }));});
                })}
// .then(() => {
//                 dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));})
            //     });
            // setContractCount(1);
            console.log("here's my contract data: id = ",selectorContractId, " count = ", contractCount);

    };


    // useEffect(() => {
    //     console.log("Handle add guilds triggered.");
    //     handleAddGuilds()
    //     // handleAdvance();
    //     dispatchData(changeWorkQueue({guildMultiSelectState: false}));
    // }, [useSelector((state) => state.workQueueSlc.value.guildMultiSelectState === true)]);
    //


    return (

        <Box>
            {(
                    ((rowContractData.contractLevel === "Property" ||
                        rowContractData.contractLevel === "Guild"
                            || rowContractData.contractLevel === "Option"
                            || rowContractData.contractLevel === "Cast"
                            || rowContractData.contractLevel === "Engagement")
                        &&
                        (rowContractData.comboStatus !== "Approved"
                            || rowContractData.comboStatus !== "Finalized"))
                ) &&
                <Box>
                <MenuItem
                    onClick= {() =>handleAddClick()}
                >
                    <ListItemIcon>
                        <AddCircleOutlineIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Add</ListItemText>
                </MenuItem>
        {/*        <Dialog*/}
        {/*        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}*/}

        {/*        open={confirmOpen} onClose={handleConfirmClose}*/}
        {/*>*/}
        {/*    <DialogTitle>Add Contract</DialogTitle>*/}
        {/*    <DialogContent dividers>*/}
        {/*        /!*<form*!/*/}
        {/*        /!*    onSubmit={handleSubmit((data)=>        onSubmit(data))}*!/*/}
        {/*        /!*>*!/*/}
        {/*        {selectorContractId === 0 && <Typography>Start a new contract from scratch</Typography>}*/}
        {/*        /!*<p>Add x cast-level contracts under this contract</p>*!/*/}
        {/*        /!*<Typography>{selectorContractLevel === null && ''}*!/*/}

        {/*        /!*<p>{selectorContractId}</p>*!/*/}
        {/*        /!*<p>{selectorContractName}</p>*!/*/}
        {/*        /!*<p>{selectorContractLevel}</p>*!/*/}
        {/*        {selectorContractId !== 0 && <div>*/}
        {/*            /!*<Stack direction="row" spacing={1}>*!/*/}
        {/*            <Typography>Add </Typography>*/}
        {/*            <Input*/}
        {/*                // defaultValue= "1"*/}
        {/*                value= {contractCount}*/}
        {/*                // onChange={handleChange}*/}
        {/*                sx={{ width: 50 }}*/}
        {/*            />*/}
        {/*            {selectorContractLevel === 'Guild' &&  <Typography> Cast-level contract(s) under </Typography>}*/}
        {/*            {(selectorContractLevel === 'Cast' && selectorContractGuild === 'SAG') &&  <Typography> Engagement-level contract(s) under </Typography>}*/}
        {/*            /!*</Stack>*!/*/}
        {/*            <Typography>Contract {selectorContractName} ({selectorContractId})</Typography>*/}
        {/*            <Typography>within {selectorContractGuild} on Product {selectorContractProduct}</Typography></div>}*/}
        {/*        /!*<RadioGroup*!/*/}
        {/*        /!*    ref={radioGroupRef}*!/*/}
        {/*        /!*    aria-label="ringtone"*!/*/}
        {/*        /!*    name="ringtone"*!/*/}
        {/*        /!*    value={value}*!/*/}
        {/*        /!*    onChange={handleChange}*!/*/}
        {/*        /!*>*!/*/}
        {/*        /!*    {options.map((option) => (*!/*/}
        {/*        /!*        <FormControlLabel*!/*/}
        {/*        /!*            value={option}*!/*/}
        {/*        /!*            key={option}*!/*/}
        {/*        /!*            control={<Radio />}*!/*/}
        {/*        /!*            label={option}*!/*/}
        {/*        /!*        />*!/*/}
        {/*        /!*    ))}*!/*/}
        {/*        /!*</RadioGroup>*!/*/}
        {/*        /!*</form>*!/*/}
        {/*    </DialogContent>*/}
        {/*    <DialogActions>*/}
        {/*        <Button  onClick={handleConfirmClose}>*/}
        {/*            Cancel*/}
        {/*        </Button>*/}
        {/*        <Button autoFocus onClick={handleConfirmAdd}>Ok</Button>*/}
        {/*        /!*<Button type= "submit" autoFocus onClick={onSubmit()}>Ok</Button>*!/*/}
        {/*    </DialogActions>*/}

        {/*</Dialog>*/}

                    <Dialog
                        // open={false} onClose={handleConfirmClose}
                        open={confirmOpen} onClose={handleConfirmClose}
                    >
                        <DialogTitle>Add Contract</DialogTitle>

                        <DialogContent>
                            {selectorContractId === 0 ? (
                                <DialogContentText>
                                    Start a new contract from scratch.
                                </DialogContentText>
                            ) : (
                                <DialogContentText>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                                        <span>Add</span>
                                        <TextField
                                            value={contractCount}
                                            onChange={(e) => setContractCount(e.target.value)}
                                            type="number"
                                            size="small"
                                            sx={{ width: 90 }}
                                            inputProps={{ min: 1 }}
                                        />
                                        <span>
            {selectorContractLevel === 'Guild' && 'Cast-level contract(s)'}
                                            {selectorContractLevel === 'Cast' && selectorContractGuild === 'SAG' && 'Engagement-level contract(s)'}
                                            {(selectorContractLevel !== 'Guild' && !(selectorContractLevel === 'Cast' && selectorContractGuild === 'SAG')) && 'contract(s)'}
                                            {' '}under Contract {selectorContractName} ({selectorContractId}) within {selectorContractGuild} on Product {selectorContractProduct}.
          </span>
                                    </Box>
                                </DialogContentText>
                            )}
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={handleConfirmClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmAdd} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>



                </Box>
            }
        </Box>

    )

}
